import React, { FC } from 'react';
import classNames from 'classnames';
import { OrderPartsImg } from '@root/app/react/uikit';
import { OrdermadeModal } from '@app/react/uikit/Modal';
import { OrderSelectBaseLayout } from '@component/OrderSelectBaseLayout';
import {
    OrderProductCategoryList,
    OrderProductCategoryListProps,
} from '@component/OrderProductCategoryList';
import { OrderPartsHelpShaft } from '@component/OrderPartsHelp';
import { useMediaDesktop } from '@app/react/common/useMedia';

export { SELECT_ALL } from '@component/OrderProductCategoryList';

interface IOrderShaftSelectComponentProps
    extends OrderProductCategoryListProps {
        className?: string;
        isHelpOpen: boolean;
        handleHelpOpen: () => void;
        handleHelpClose: () => void;
}

export const OrderShaftSelectComponent: FC<IOrderShaftSelectComponentProps> = ({
    rootRef,
    className,
    categoryId,
    subCategoryId,
    categoryData,
    subCategoryData,
    categoryChange,
    subCategoryChange,
    selectedProduct,
    onSelectProduct,
    viewData,
    isHelpOpen,
    handleHelpOpen,
    handleHelpClose,
}) => {
    const rootClassName = classNames('order-shaft-select', className);
    const isDesktop = useMediaDesktop();

    return (
        <>
            <OrderSelectBaseLayout
                rootRef={rootRef}
                classNames={{ root: rootClassName }}
                header={isDesktop && (
                    <OrderPartsImg
                        partsName="シャフト"
                        showHelpBtn
                        onHelpClick={handleHelpOpen}
                    />
                )}
                body={(
                    <OrderProductCategoryList
                        rootRef={rootRef}
                        categoryId={categoryId}
                        subCategoryId={subCategoryId}
                        categoryData={categoryData}
                        subCategoryData={subCategoryData}
                        categoryChange={categoryChange}
                        subCategoryChange={subCategoryChange}
                        selectedProduct={selectedProduct}
                        onSelectProduct={onSelectProduct}
                        viewData={viewData}
                    />
                )}
            />
            {selectedProduct === null && <OrdermadeModal status />}
            <OrderPartsHelpShaft
                isOpen={isHelpOpen}
                handleOpen={handleHelpOpen}
                handleClose={handleHelpClose}
            />
        </>
    );
};
